module.exports = __webpack_public_path__ + "8f449365e8c166a84991fbb53f7ed787.pdf";